// covered-by: frontends/carrie/src/routes/ask-puntt/components/__tests__/ChatMessage.test.tsx

/**
 * The numbered claim under an answer. Hover shows the same source card as the
 * badge in the prose; a click still focuses the rail and opens the rule dialog.
 */

import { useTranslation } from "react-i18next";

import { SourceHoverCard } from "../../../components/ask-puntt-sources";
import { claimCitationHoverSource } from "../../../components/ClaimCitationLink";
import { type LinkableClaim } from "../../../plugins/rehype-claim-citation";
import { type TicketMessageCitation } from "../../../utils/citations";

const CHIP_CLASS =
  "transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-puntt-accent-9";

export function CitedClaimFooterChip({
  citation,
  n,
  messageId,
  index,
  selected,
  statement,
  provenance,
  guest,
  onSelect,
}: {
  citation: Extract<TicketMessageCitation, { ruleId: string }>;
  n: number;
  messageId: string;
  index: number;
  selected: boolean;
  statement: string;
  provenance?: Pick<
    LinkableClaim,
    "memoryId" | "memoryLabel" | "chatId" | "chatLabel"
  >;
  guest: boolean;
  onSelect: () => void;
}) {
  const { t } = useTranslation("ui");
  const ruleId = citation.ruleId;
  const source = claimCitationHoverSource(
    {
      ruleId,
      statement,
      memoryId: provenance?.memoryId,
      memoryLabel: provenance?.memoryLabel,
      chatId: provenance?.chatId,
      chatLabel: provenance?.chatLabel,
      index: n,
    },
    citation,
    (page) => t("askPuntt.sources.pageLabel", { page }),
    guest,
  );

  return (
    <SourceHoverCard
      sources={[source]}
      testIdPrefix={`chat-citation-${messageId}`}
      groupId={`${messageId}-${index}`}
      trigger="chip"
      density="cell"
      chipLabel={String(n)}
      chipAriaLabel={t("citedClaimsPanel.chipAriaLabel", { n, statement })}
      chipTestId={`chat-citation-chip-${messageId}-${index}`}
      selected={selected}
      chipClassName={CHIP_CLASS}
      onTriggerClick={onSelect}
    />
  );
}
